import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/boctham/BocthamHome.vue'),
    },
    {
      path: '/boctham/:code',
      name: 'boctham',
      component: () => import('@/views/boctham/BocthamProcess.vue'),
    },
    // {
    //   path: '/report',
    //   name: 'boctham-report',
    //   component: () => import('@/views/boctham/BocthamReport.vue'),
    // },
    {
      path: '/upload-cam-ket/:code',
      name: 'upload-commitment',
      component: () => import('../views/customers/UploadCommitment.vue'),
    },
    {
      path: '/verify-token/:code',
      name: 'verify-token',
      component: () => import('../views/customers/VerifyToken.vue'),
    },
    {
      path: '/contract/:code/:token',
      name: 'contract-public',
      component: () => import('../views/contract/ContractPublic.vue'),
    },
    {
      path: '/thanh-toan-2/:token',
      name: 'contract-phase2-upload',
      component: () => import('../views/contract/Phase2PaymentUpload.vue'),
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'not-found',
      component: () => import('@/views/common/NotFound.vue'),
    },
    {
      path: '/admin',
      redirect: '/admin/dashboard',
    },
    {
      path: '/admin/login',
      name: 'admin-login',
      component: () => import('@/views/admin/Login.vue'),
      meta: { requiresGuest: true },
    },
    {
      path: '/admin/dashboard',
      name: 'admin-dashboard',
      component: () => import('@/views/admin/Dashboard.vue'),
      meta: { requiresAuth: true },
    },
    {
      path: '/admin/users',
      name: 'admin-users',
      component: () => import('@/views/admin/Users.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/customers',
      name: 'admin-customers',
      component: () => import('@/views/admin/Customers.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/boctham',
      name: 'admin-boctham',
      component: () => import('@/views/admin/Boctham.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/rooms',
      name: 'admin-rooms',
      component: () => import('@/views/admin/Rooms.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/email-logs',
      name: 'admin-email-logs',
      component: () => import('@/views/admin/EmailLogs.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/deposit-notification',
      name: 'admin-deposit-notification',
      component: () => import('@/views/admin/DepositNotification.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/contract-signing-notification',
      name: 'admin-contract-signing-notification',
      component: () => import('@/views/admin/ContractSigningNotification.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/customer-apartments',
      name: 'admin-customer-apartments',
      component: () => import('@/views/admin/CustomerApartments.vue'),
      meta: { requiresAuth: true, requiresAdmin: true },
    },
    {
      path: '/admin/contracts',
      name: 'admin-contracts',
      component: () => import('@/views/contract/Contracts.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
    {
      path: '/admin/contracts/:id/check',
      name: 'admin-contract-check',
      component: () => import('@/views/contract/ContractCheck.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
    {
      path: '/admin/contract-payments',
      name: 'admin-contract-payments',
      component: () => import('@/views/admin/ContractPayments.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
    {
      path: '/admin/contract-payments/:id/history',
      name: 'admin-contract-payment-history',
      component: () => import('@/views/admin/ContractPaymentHistory.vue'),
      meta: { requiresAuth: true, requiresAdmin: false },
    },
  ],
})

// Navigation guards
router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()

  // console.log('Router guard - to:', to.path, 'isAuthenticated:', authStore.isAuthenticated, 'requiresAuth:', to.meta.requiresAuth, 'user:', authStore.user, 'token:', authStore.token)

  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    // console.log('Redirecting to login - not authenticated')
    next('/admin/login')
  } else if (to.meta.requiresGuest && authStore.isAuthenticated) {
    // console.log('Redirecting to dashboard - already authenticated')
    next('/admin/dashboard')
  } else if (to.meta.requiresAdmin) {
    // Kiểm tra role admin
    const userRole = authStore.user?.role
    if (userRole !== 'admin') {
      // Nếu không phải admin, chuyển về dashboard
      next('/admin/dashboard')
    } else {
      next()
    }
  } else {
    // console.log('Allowing navigation to:', to.path)
    next()
  }
})

export default router
